module.exports = __webpack_public_path__ + "img/car_25.5f3388db.jpg";